
const APIs = {
  modules: '/d/json/module',
  companyName: '/d/json/company/name',
  companyLanguages: '/d/json/company/language?format=full'
};

export default APIs;
